import { deliveryUnitAPI } from "../../axios";

export const state = {
    isPostedRealignmentLoading: false,
    isApprovedRealignmentLoading: false
}

export const mutations = {
    SET_POSTED_REALIGNMENT_LOADING(state, data){
        state.isPostedRealignmentLoading = data;
    },
    SET_APPROVED_REALIGNMENT_LOADING(state, data){
        state.isApprovedRealignmentLoading = data;
    }
}

export const actions = {

    //Realignment
    GetRealignment(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetRealignmentByDep(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Department/${data.departmentId}/${data.cycle}`);
    },
    GetSingleRealignment(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/${data}`);
    },
    UpdateRealignment(context, data){
        return deliveryUnitAPI.put(`RealignmentRequest/Update/${data.id}`, data);
    },
    DeleteRealignment(context, data){
        return deliveryUnitAPI.delete(`RealignmentRequest/Remove/${data}`);
    },
    CreateRealignment(context, data){
        return deliveryUnitAPI.post(`RealignmentRequest/Create/${data.deliveryUnitId}/${data.cycle}`, data);
    },
    PostRealignment(context, data){
        return deliveryUnitAPI.post(`RealignmentRequest/Post/${data}`);
    },
    ReturnRealignment(context, {id, remarks}){
        return deliveryUnitAPI.post(`RealignmentRequest/Return/${id}`,JSON.stringify(remarks), {headers: {"Content-Type": "application/json"}});
    },
    ApproveRealignment(context, data){
        return deliveryUnitAPI.post(`RealignmentRequest/Approve/${data}`);
    },
    GetPostedRealignmentCampus(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Posted/${data.campusId}/${data.cycle}`);
    },
    GetApprovedRealignmentCampus(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Approved/${data.campusId}/${data.cycle}`);
    },
    GetPostedRealignmentDU(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Posted/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetApprovedRealignmentDU(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Approved/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetReturnedRealignmentDU(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Returned/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetAvailableAPI(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Apis/Available/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetRealignmentHistory(context, data){
        return deliveryUnitAPI.get(`RealignmentRequest/Logs/${data}`);
    },
    UndoApproval(context, data){
        return deliveryUnitAPI.post(`RealignmentRequest/UndoApproval/${data}`);
    }
}